<template>
  <header :class="$route.name==='article'||$route.name==='how'?'header-white':'header'">
    <div class="exitblock" @click="$root.requestModal = 2"></div>
    <div class='container'>
      <div class="header__wrapper">
        <router-link to="/" class="header__logo" v-if="$route.name!=='article'&&$route.name!=='how'">
          <img class="header__logo-link" src="/static/img/header/logo.svg" alt="Логотип" width="167" height="50" />
          <img class="m-logo" src="/static/img/header/m-logo.svg" alt="Логотип" width="120" height="36" />
        </router-link>
        <router-link to="/" class="header__logo" v-else>
          <img class="header__logo-link" src="/static/img/header/logo-w.svg" alt="Логотип" width="167" height="50" />
          <img class="m-logo" src="/static/img/header/m-logo.svg" alt="Логотип" width="120" height="36" />
        </router-link>
        <div class="header__burger">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <nav class="header__menu">
          <ul class="menu__list">
            <li><router-link to="/groups/373" class="menu__link">Быстрый возврат прав</router-link></li>
            <li><router-link to="/how-it-works" class="menu__link">Как это работает</router-link></li>
            <li><router-link to="/win" class="menu__link">Как самому выиграть дело в суде</router-link></li>
            <li><router-link to="/prover-avtourista" class="menu__link">Проверь своего юриста</router-link></li>
          </ul>
        </nav>
      </div>
    </div>
    <div v-if="2*2 === 5" id="modalSubscribe" style="display: none;max-height: initial" class="modal">
      <div class="modal-wrapper">
        <a id="closeSocPopup" @click="closedPopUp"><img src="../../../static/img/header/closePopupSoc.svg" alt=""></a>
        <div class="title">
          Спасибо!
          <p>
            Мы свяжемся с Вами и ответим на все Ваши вопросы. <br><br>
            Выберите удобный способ для связи:
          </p>
        </div>
        <div class="image-social_wrapper">
          <a onclick="window.open('https://wa.me/79250194968', '_blank', 'toolbar=1, scrollbars=1, resizable=1, width=' + 1015 + ', height=' + 800);"><img src="../../../static/img/header/soc/wa.jpg" alt=""></a>
          <a onclick="window.open('tg://resolve?domain=Avtourist_bot', '_blank', 'toolbar=1, scrollbars=1, resizable=1, width=' + 1015 + ', height=' + 800);"><img src="../../../static/img/header/soc/tg.jpg" alt=""></a>
          <a onclick="window.open('viber://pa?chatURI=avtourist-bot&context=welcome', '_blank', 'toolbar=1, scrollbars=1, resizable=1, width=' + 1015 + ', height=' + 800);"><img src="../../../static/img/header/soc/vb.jpg" alt=""></a>
          <a onclick="window.open('https://vk.com/write-7375007', '_blank', 'toolbar=1, scrollbars=1, resizable=1, width=' + 1015 + ', height=' + 800);"><img src="../../../static/img/header/soc/vk.jpg" alt=""></a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      url: null
    }
  },
  created () {
    this.url = this.$router.currentRoute.path
  },
  watch: {
    $route (to, from) {
      this.url = to.path
    }
  },
  methods: {
    closedPopUp () {
      document.getElementById('modalSubscribe').style.display = 'none'
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(80,80,80, 0.8);
    z-index: 10000000000;
  }
  .modal .modal-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: fixed;
    top: 50%;
    left: 50%;
    max-width: 500px;
    background: #ffffff;
    padding: 25px;
    border-radius: 10px;
    transform: translateX(-50%) translateY(-50%);
  }
  .modal .modal-wrapper .title {
    margin-bottom: 20px;
  }
  .modal .modal-wrapper .image-social_wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .modal .modal-wrapper .image-social_wrapper a{
    margin: 1px;
  }
  #closeSocPopup {
    position: absolute;
    top: 15px;
    right: 15px;
  }
  .modal-btn button {
    display: block;
    height: 48px;
    background: #20D152;
    margin: 0 auto;
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.15);
    border-radius: 6px;
    color: #FFFFFF;
    font-weight: bold;
    font-size: 16px;
  }
  .modal-btn button:hover {
    transform: scale(1.02);
  }
</style>



// WEBPACK FOOTER //
// src/components/include/header.vue